import { c as _c } from "react/compiler-runtime";
import { Loader2 } from "lucide-react";
export default function Loader() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex h-full items-center justify-center pt-8"><Loader2 className="animate-spin" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}